import { useState } from 'react';
import axios from 'axios';

const API = '/api';

const emptyForm = {
  date: '',
  description: '',
  category: '',
  subCategory: '',
  amount: '',
  type: 'expense',
  transferDirection: 'out',
  notes: '',
  isRecurring: false,
  currency: 'AUD',
  linkedTransactionId: ''
};

function TransactionForm({ onSaved, editData, onCancel, transactions = [] }) {
  const [form, setForm] = useState(editData ? {
    ...editData,
    date: editData.date ? new Date(editData.date).toISOString().split('T')[0] : '',
    linkedTransactionId: editData.linkedTransactionId ?? ''
  } : emptyForm);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      ...form,
      amount: parseFloat(form.amount),
      date: new Date(form.date).toISOString(),
      linkedTransactionId: form.linkedTransactionId ? parseInt(form.linkedTransactionId) : null
    };

    if (form.type === 'transfer' && form.transferDirection === 'out') {
      payload.amount = -Math.abs(payload.amount);
    } else if (form.type === 'transfer' && form.transferDirection === 'in') {
      payload.amount = Math.abs(payload.amount);
    }

    delete payload.transferDirection; //temporary until backend supports it

    if (editData) {
      await axios.put(`${API}/transactions/${editData.id}`, payload);
    } else {
      await axios.post(`${API}/transactions`, payload);
    }
    onSaved();
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-grid">
        <div className="form-group" style={{ gridColumn: 'span 3' }}>
          <label>Link to Transaction</label>
          <select
            name="linkedTransactionId"
            value={form.linkedTransactionId}
            onChange={handleChange}
          >
            <option value="">None</option>
            {transactions
              .filter(t => t.id !== editData?.id)
              .map(t => (
                <option key={t.id} value={t.id}>
                  {new Date(t.date).toLocaleDateString('en-AU', { day: '2-digit', month: 'short', year: '2-digit' })} — {t.description} (${t.amount})
                </option>
              ))}
          </select>
        </div>
        <div className="form-group">
          <label>Date</label>
          <input type="date" name="date" value={form.date} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Description</label>
          <input type="text" name="description" value={form.description} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Type</label>
          <select name="type" value={form.type} onChange={handleChange}>
            <option value="expense">Expense</option>
            <option value="income">Income</option>
            <option value="transfer">Transfer</option>
          </select>
        </div>
        <div className="form-group">
          <label>Amount</label>
          <input type="number" name="amount" value={form.amount} onChange={handleChange} step="0.01" required />
        </div>
        <div className="form-group">
          <label>Category</label>
          <input type="text" name="category" value={form.category} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Sub Category</label>
          <input type="text" name="subCategory" value={form.subCategory} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Notes</label>
          <input type="text" name="notes" value={form.notes} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Recurring</label>
          <select name="isRecurring" value={form.isRecurring} onChange={handleChange}>
            <option value={false}>No</option>
            <option value={true}>Yes</option>
          </select>
        </div>
        {form.type === 'transfer' && (
          <div className="form-group">
            <label>Direction</label>
            <select name="transferDirection" value={form.transferDirection || 'out'} onChange={handleChange}>
              <option value="out">Outgoing (−)</option>
              <option value="in">Incoming (+)</option>
            </select>
          </div>
        )}
      </div>
      <div className="form-actions">
        <button type="submit" className="btn-primary">{editData ? 'Update' : 'Add Transaction'}</button>
        {onCancel && <button type="button" className="btn-cancel" onClick={onCancel}>Cancel</button>}
      </div>
    </form>
  );
}

export default TransactionForm;